import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface CreateNoNCalendarYearRequest {
  companyId: number;
  noOfPeriods: number;
  periodLength: number;
  periodType: 0 | 1 | 2;
}

const useCreateNoNCalendarYearApi = () => {
  const call = useCallback(
    (req?: CreateNoNCalendarYearRequest) =>
      new Promise((resolve, reject) => {
        axiosInstance
          .post(api.createNoNCalendarYear, req)
          .then((data) => {
            resolve(data.data);
            return data.data;
          })
          .catch((e) => {
            reject(new Error(e));
          });
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    createNoNCalendarYear: execute,
    isCreateNoNCalendarLoading: isLoading,
  };
};

export default useCreateNoNCalendarYearApi;
